export default __webpack_public_path__ + "static/media/asuransi-astra.c7680793.svg";